import React, { useContext, useReducer, useMemo, useEffect } from 'react';

import { FEATURE_FLAGS } from './helpers/constants';
import { formsReducer } from './helpers/reducers/forms';
import {
  useForgeUserMapping,
  useAllPgUsers,
  usePgUser,
  useAllFormTemplates,
} from './hooks';
import {
  PlangridLaunchDarklyProvider,
  usePlangridFeatureFlag,
} from './PlangridLaunchDarklyProvider';

const FormsContext = React.createContext({});
const useFormsContext = () => useContext(FormsContext);

// flags that are used outside of react component
const formsFeatureFlags = {};

const FormsProvider = ({ children }) => {
  const [state, dispatch] = useReducer(formsReducer, {
    newForm: {},
    newFormTemplate: {},
    templateCategories: [],
  });
  const { data: forgeUserMapping, isLoading: isLoadingForgeUserMapping } =
    useForgeUserMapping();
  const { data: pgProjectUsers, isLoading: isLoadingPgProjectUsers } =
    useAllPgUsers();
  const { data: formTemplates, isLoading: isLoadingFormTemplates } =
    useAllFormTemplates();
  const { data: pgProjectUser, isLoading: isLoadingPgProjectUser } =
    usePgUser();

  const value = useMemo(
    () => ({
      ...state,
      dispatch,
      forgeUserMapping: forgeUserMapping || {},
      isLoadingForgeUserMapping,
      isLoadingPgProjectUsers,
      pgProjectUsers: pgProjectUsers || [],
      formTemplates,
      isLoadingFormTemplates,
      pgProjectUser,
      isLoadingPgProjectUser,
    }),
    [
      state,
      forgeUserMapping,
      isLoadingForgeUserMapping,
      isLoadingPgProjectUsers,
      pgProjectUsers,
      formTemplates,
      isLoadingFormTemplates,
      pgProjectUser,
      isLoadingPgProjectUser,
    ],
  );

  return (
    <PlangridLaunchDarklyProvider>
      <LoadFeatureFlags />
      <FormsContext.Provider value={value}>{children}</FormsContext.Provider>
    </PlangridLaunchDarklyProvider>
  );
};

const LoadFeatureFlags = () => {
  const { value: isScalingFormsM7Enabled } = usePlangridFeatureFlag(
    FEATURE_FLAGS.SCALING_FORMS_M7,
    false,
  );

  useEffect(() => {
    formsFeatureFlags[FEATURE_FLAGS.SCALING_FORMS_M7] = isScalingFormsM7Enabled;
  }, [isScalingFormsM7Enabled]);
  return null;
};

export { useFormsContext, FormsProvider, formsFeatureFlags };
